import { EllipsisVerticalIcon } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';

import type { ContactSheetData } from '@/entities/client';
import { openEditContactProfileSheet } from '@/features/client/edit-contact-profile';
import { SheetClose, SheetCloseButton, SheetHeader } from '@/shared/ui/panels/sheet-panel';

// `contact` is undefined until the profile has loaded, so Edit Profile never opens a form with
// nothing to prefill it.
type Props = {
    contact: ContactSheetData | undefined;
};

export function ContactDetailsSheetActionBar({ contact }: Props) {
    return (
        <SheetHeader variant="breadcrumbs" className="shrink-0 gap-2">
            <div className="flex items-center gap-2">
                <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    disabled={!contact}
                    onClick={() => contact && openEditContactProfileSheet(contact)}
                >
                    Edit Profile
                </Button>
                <Button type="button" variant="outline" size="sm" disabled={!contact}>
                    Convert to Client
                </Button>
            </div>
            <div className="flex items-center gap-2">
                <Button
                    type="button"
                    variant="ghost"
                    size="icon-sm"
                    aria-label="Contact options"
                    disabled={!contact}
                >
                    <EllipsisVerticalIcon className="size-4" />
                </Button>
                <SheetClose asChild>
                    <SheetCloseButton />
                </SheetClose>
            </div>
        </SheetHeader>
    );
}
